// extracted by mini-css-extract-plugin
export default {"customTab":"custom-tab_customTab__rxYYb","isActiveTab":"custom-tab_isActiveTab__Q1cCE","title":"custom-tab_title__8YaHg","icon":"custom-tab_icon__W1gSJ"};